import { Steps } from "antd";
import { useUploadCsvSteps } from "../../../../hooks/Faltantes/useUploadCsvSteps";

const StepsToUpload = () => {
  const { current, setCurrent, isblocked } = useUploadCsvSteps();
  const onChange = (value) => {
    setCurrent(value);
  };

  return (
    <>
      <Steps
        className="mb-3"
        type="navigation"
        current={current}
        onChange={onChange}
        size="small"
        items={[
          {
            // status: "process",
            title: "Remitentes",
          },
          {
            // status: "wait",
            title: "Cargar archivo",
            disabled: isblocked,
          },
        ]}
      />
    </>
  );
};
export default StepsToUpload;
